import { usePage } from '@inertiajs/react';

import { Footer } from '@/theme2/components/layout/Footer';
import { Header } from '@/theme2/components/layout/Header';
import { TopBar } from '@/theme2/components/layout/TopBar';

export default function StoreLayoutTheme2({ children }) {
    const { frontendTheme } = usePage().props;

    return (
        <div
            className="min-h-screen bg-[#fff8fb] text-slate-900 antialiased"
            data-frontend-theme={frontendTheme?.name ?? 'theme2'}
        >
            <div className="mx-auto flex min-h-screen w-full max-w-[1440px] flex-col px-3 py-3 sm:px-4 lg:px-6 lg:py-6">
                <div className="overflow-hidden rounded-[2rem] border border-rose-100 bg-[linear-gradient(180deg,rgba(255,255,255,0.95),rgba(255,246,249,0.9))] shadow-[0_20px_80px_rgba(245,27,117,0.08)] backdrop-blur-xl">
                    <TopBar />
                    <Header />
                </div>

                <main className="flex-1 py-4 sm:py-6 lg:py-8">
                    <div className="overflow-hidden rounded-[2rem] border border-rose-100 bg-[linear-gradient(180deg,rgba(255,255,255,0.94),rgba(255,247,250,0.92))] p-3 shadow-[0_24px_80px_rgba(245,27,117,0.08)] backdrop-blur-xl sm:p-4 lg:p-6">
                        {children}
                    </div>
                </main>

                <div className="overflow-hidden rounded-[2rem] border border-rose-100 bg-[linear-gradient(180deg,rgba(255,255,255,0.95),rgba(255,245,248,0.9))] shadow-[0_20px_80px_rgba(245,27,117,0.08)] backdrop-blur-xl">
                    <Footer />
                </div>
            </div>
        </div>
    );
}
